module.exports = __webpack_public_path__ + "img/013.41cd1efa.jpg";